import { getCurrentConnectionInfo } from 'portal-sdk';
import Stardog, { Connection as StardogConnection } from 'stardog';
import { refetchConnectionToken } from 'vet-bones/utils/portal';

export const retryRequestWrapper = async <R extends Stardog.HTTP.Body>(
  stardogConnection: StardogConnection,
  wrappedRequest: (stardogConn: StardogConnection) => Promise<R>
) => {
  let response = await wrappedRequest(stardogConnection);

  if (response && response.status === 401) {
    const connectionIdx =
      getCurrentConnectionInfo(window)?.connectionIndex || 0;
    const updatedToken = await refetchConnectionToken(connectionIdx);
    if (updatedToken) {
      // @ts-ignore
      // eslint-disable-next-line no-param-reassign
      stardogConnection.token = updatedToken;
      response = await wrappedRequest(stardogConnection);
    }
  }

  return response;
};
